const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Diptanshu Banerjee</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Technical Head, UPES-CSI</li>
    <li>
        Driving technical innovation and excellence.
    </li>
    <li>
        Mentoring students in emerging technologies.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
